import { render } from "./EmojiReactions.vue?vue&type=template&id=444d278c&scoped=true"
import script from "./EmojiReactions.vue?vue&type=script&lang=js"
export * from "./EmojiReactions.vue?vue&type=script&lang=js"

import "./EmojiReactions.vue?vue&type=style&index=0&id=444d278c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-444d278c"]])

export default __exports__